import {FormattedMessage} from "react-intl";
import React from "react";

export default function FormattedOption({id, value}){
    return <FormattedMessage id={id}>
        {(message)=><option value={value}>{message}</option>}
    </FormattedMessage>
}
